import { Dialog, DialogContent, DialogTitle, IconButton, Typography } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import { FC } from "react";

interface IModalSCR {
    open: boolean;
    onClose: () => void;
}

const ModalSCR: FC<IModalSCR> = ({
    open,
    onClose
}) => {
    return <Dialog className="ModalSCR" open={open}>
        <DialogTitle>
            <strong>Acesso ao histórico financeiro</strong>
            <div className="close-button">
                <IconButton onClick={() => {
                    onClose();
                }}>
                    <Close />
                </IconButton>
            </div>
        </DialogTitle>
        <DialogContent>
            <Typography variant="h6">O que é SCR?</Typography>
            <Typography variant="body1">
                É o sistema de informações de crédito do Banco Central do Brasil (Bacen). Ele tem dados de operações de crédito que foram enviados pelas instituições financeiras.
            </Typography>
            <Typography variant="body1">
                Esse histórico tem como finalidade prover informações ao Bacen para monitorar o crédito no sistema financeiro e o exercício de suas atividades de fiscalização, além de possibilitar o intercâmbio de informações entre as instituições financeiras.
            </Typography>
            <Typography variant="body1">
                Se quiser, o cliente pode solicitar o detalhamento dessas informações diretamente ao Bacen.
            </Typography>
            <Typography variant="h6">Com o que você está concordando? </Typography>
            <Typography variant="body1">
                Ao continuar com a simulação do financiamento, o cliente autoriza o Banco Votorantim, empresas do seu conglomerado econômico, eventuais cessionários e instituições que adquiram ou manifestem interesse em adquirir, ou receber em garantia as operações de crédito, a enviar, consultar e incluir informações sobre suas operações de crédito na forma de regulamentação vigente.
            </Typography>
            <Typography variant="body1">
                Para corrigir ou excluir informações do SCR, cadastrar medida judicial ou registrar manifestação de discordância quanto às informações que constam nesse sistema, o cliente precisa estar ciente que deverá entrar em contato com a instituição que reportou a informação ao Bacen.
            </Typography>
        </DialogContent>
    </Dialog>
}

export { ModalSCR } 